import { useRef } from 'react';

import { useABLincoln } from '@vimeo/ablincoln';
import { Membership } from '@vimeo/gctl-api/models/components/schemas/membership/Membership';

/**
 * TODO: ACT-299: Show quota warning widget to free users who've reached 50% of their quota
 * https://vimean.atlassian.net/browse/ACT-299
 */
export function useQuotaWarningFreeUsers() {
  const bucketUser = useABLincoln();
  const bucketRef = useRef<string | null>(null);

  return (accountType: Membership['type'], amountOfVideosUploaded: number) => {
    if (!bucketRef.current && accountType === 'free' && amountOfVideosUploaded === 1) {
      bucketRef.current = bucketUser(
        'JS.Upload.ShowQuotaWarningToFreeUsers',
        'quota_warning_free_users',
        'control',
      );
    }

    return bucketRef.current;
  };
}
